import React from 'react';
import { Stack, Typography, Grid, useMediaQuery } from '@mui/material';
import { CommodityList } from '../../../redux/api/commodities/commodities.model';
import TwCommodityOverlay from '../TwCommoditiesBuilder/desktop/TwCommodityOverlay';
import { MeasurementSystem } from '../../../providers/User/User.model';
import { useCommoditySettings } from '../../../hooks/useCommoditySettings';
import NumberUtils from '../../../utils/numberUtils';
import { styled, Theme } from '@mui/material/styles';
import TwMobileCommodityOverlay from '../TwCommoditiesBuilder/mobile/TwMobileCommodityOverlay';

interface TwCommoditiesOverlayWrapperProps {
  commodities: CommodityList[];
}

const TotalLabelTypography = styled(Typography)(({ theme }) => ({
  color: '#6B7280',
  fontWeight: 600,
  fontSize: '1rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
  },
}));

const TotalValueTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: '#374151',
  textAlign: 'center',
  fontSize: '1rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
  },
}));

export const TwCommoditiesOverlayWrapper = ({ commodities }: TwCommoditiesOverlayWrapperProps): JSX.Element => {
  const { measurementSystem } = useCommoditySettings();
  const matchesMobileOrTablet = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  const totalQuantity = commodities.reduce((acc, commodity) => acc + (commodity?.quantity || 0), 0);
  const totalWeight = commodities.reduce((acc, commodity) => acc + (commodity?.weight || 0), 0);

  return (
    <Stack flexDirection={'column'} sx={{ marginTop: '2rem' }}>
      <Typography
        component="h5"
        className="load-detail__data-container__data--title"
        sx={{ marginBottom: '1rem' }}
      >
        Commodities
      </Typography>
      {commodities.map((commodity) => {
        if (matchesMobileOrTablet) {
          return <TwMobileCommodityOverlay key={commodity.id} commodity={commodity} />;
        }

        return <TwCommodityOverlay key={commodity.id} commodity={commodity} />;
      })}
      <Grid container alignItems="center" spacing={0} mb={2}>
        <Grid item xs={8} sm={9} sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          <TotalLabelTypography>
            TOTAL
          </TotalLabelTypography>
        </Grid>
        <Grid item xs={4} sm={3}>
          <Grid container alignItems="center" spacing={0}>
            <Grid item xs={3} sm={5}>
              <TotalValueTypography sx={{ mr: 2 }}>
                {NumberUtils.formatNumber(totalQuantity)}
              </TotalValueTypography>
            </Grid>
            <Grid item xs={8} sm={5}>
              <TotalValueTypography sx={{ ml: { xs: 3, sm: 1.5 } }}>
                {NumberUtils.formatNumber(totalWeight)}
                {measurementSystem === MeasurementSystem.IMPERIAL ? ' lb' : ' kg'}
              </TotalValueTypography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default TwCommoditiesOverlayWrapper;
